/* ============================================================
   Hover Video — Product Grid
   Cargado solo en template collection
   ============================================================ */

(function () {
  'use strict';

  function initHoverVideos() {
    const blocks = document.querySelectorAll('[data-product-block][data-has-hover-video]');

    blocks.forEach(function (block) {
      const video = block.querySelector('.product__media__hover-video');
      if (!video) return;

      block.addEventListener('mouseenter', function () {
        video.currentTime = 0;
        video.play().catch(function () {
          // Silencia el error si el navegador bloquea el autoplay
        });
      });

      block.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  // Inicializar al cargar la página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverVideos);
  } else {
    initHoverVideos();
  }

  // Re-inicializar si Ajaxinate carga más productos (infinite scroll)
  document.addEventListener('ajaxinate:loaded', initHoverVideos);

})();